import { render, staticRenderFns } from "./CourseFloor.vue?vue&type=template&id=d8134a08&scoped=true&"
import script from "./CourseFloor.vue?vue&type=script&lang=js&"
export * from "./CourseFloor.vue?vue&type=script&lang=js&"
import style0 from "./CourseFloor.vue?vue&type=style&index=0&id=d8134a08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8134a08",
  null
  
)

export default component.exports